export default __webpack_public_path__ + "static/media/illus12.90dadb66.png";